import { Newspaper } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { AnnouncementModal } from "@/components/announcements/AnnouncementModal";
import { useAnnouncementNews, useTodayAnnouncement } from "@/hooks/useAnnouncements";

export function AnnouncementGate() {
  const { current, handleAction } = useTodayAnnouncement();
  return <AnnouncementModal announcement={current} onAction={handleAction} />;
}

export function NewsButton({ className }: { className?: string }) {
  const navigate = useNavigate();
  const { items } = useAnnouncementNews();
  const unseen = items.filter((i) => i.state === "new").length;
  const label = unseen > 0 ? `Noticias, ${unseen} sin ver` : "Noticias";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={() => navigate("/app/news")}
          aria-label={label}
          className={cn(
            "relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-mute transition-colors hover:bg-black/[0.05] hover:text-ink-900 dark:hover:bg-white/[0.07]",
            className,
          )}
        >
          <Newspaper className="h-[18px] w-[18px]" />
          {unseen > 0 && (
            <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full border-2 border-background bg-rose-600" />
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
